module.exports = __webpack_public_path__ + "img/8.d10039a0.jpg";